import { render } from "./couponLog.vue?vue&type=template&id=22ba9524"
import script from "./couponLog.vue?vue&type=script&lang=js"
export * from "./couponLog.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__